import { render, staticRenderFns } from "./BidDurationSettings.vue?vue&type=template&id=1ab6e856"
import script from "./BidDurationSettings.vue?vue&type=script&lang=js"
export * from "./BidDurationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports